/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AdverseMediaVerificationIdQueryV1 } from '../models/adverse-media-verification-id-query-v-1';
import { AmlScreeningVerificationIdQueryV1 } from '../models/aml-screening-verification-id-query-v-1';
import { BankVerificationIdQueryV1 } from '../models/bank-verification-id-query-v-1';
import { EmailDomainVerificationIdQueryV1 } from '../models/email-domain-verification-id-query-v-1';
import { EuVatVerificationIdQueryV1 } from '../models/eu-vat-verification-id-query-v-1';
import { GlobalTinVerificationIdQueryV1 } from '../models/global-tin-verification-id-query-v-1';
import { GstVerificationIdQueryV1 } from '../models/gst-verification-id-query-v-1';
import { IbanVerificationIdQueryV1 } from '../models/iban-verification-id-query-v-1';
import { ResolveIdResponseV1 } from '../models/resolve-id-response-v-1';
import { TinVerificationIdQueryV1 } from '../models/tin-verification-id-query-v-1';
import { VerificationResultResponseV1 } from '../models/verification-result-response-v-1';


/**
 * API to query cached verification results for a supplier request
 */
@Injectable({
  providedIn: 'root',
})
export class VerificationResultsV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation resolveVerificationIdsV1
   */
  static readonly ResolveVerificationIdsV1Path = '/v1/verifications/results/resolve-ids';

  /**
   * Compute resultIds for a list of verification inputs without triggering provider calls.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resolveVerificationIdsV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resolveVerificationIdsV1$Response(params: {
    body: Array<(AdverseMediaVerificationIdQueryV1 | AmlScreeningVerificationIdQueryV1 | BankVerificationIdQueryV1 | EmailDomainVerificationIdQueryV1 | EuVatVerificationIdQueryV1 | GlobalTinVerificationIdQueryV1 | GstVerificationIdQueryV1 | IbanVerificationIdQueryV1 | TinVerificationIdQueryV1)>
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ResolveIdResponseV1>>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationResultsV1Service.ResolveVerificationIdsV1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ResolveIdResponseV1>>;
      })
    );
  }

  /**
   * Compute resultIds for a list of verification inputs without triggering provider calls.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resolveVerificationIdsV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resolveVerificationIdsV1(params: {
    body: Array<(AdverseMediaVerificationIdQueryV1 | AmlScreeningVerificationIdQueryV1 | BankVerificationIdQueryV1 | EmailDomainVerificationIdQueryV1 | EuVatVerificationIdQueryV1 | GlobalTinVerificationIdQueryV1 | GstVerificationIdQueryV1 | IbanVerificationIdQueryV1 | TinVerificationIdQueryV1)>
  },
  context?: HttpContext

): Observable<Array<ResolveIdResponseV1>> {

    return this.resolveVerificationIdsV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ResolveIdResponseV1>>) => r.body as Array<ResolveIdResponseV1>)
    );
  }

  /**
   * Path part for operation getVerificationResultsV1
   */
  static readonly GetVerificationResultsV1Path = '/v1/verifications/results/{requestId}';

  /**
   * Get all valid verification results for a request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVerificationResultsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVerificationResultsV1$Response(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<VerificationResultResponseV1>>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationResultsV1Service.GetVerificationResultsV1Path, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VerificationResultResponseV1>>;
      })
    );
  }

  /**
   * Get all valid verification results for a request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVerificationResultsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVerificationResultsV1(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<Array<VerificationResultResponseV1>> {

    return this.getVerificationResultsV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<VerificationResultResponseV1>>) => r.body as Array<VerificationResultResponseV1>)
    );
  }

  /**
   * Path part for operation getVerificationResultV1
   */
  static readonly GetVerificationResultV1Path = '/v1/verifications/results/{requestId}/{resultId}';

  /**
   * Poll a specific verification result by resultId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVerificationResultV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVerificationResultV1$Response(params: {
    requestId: string;
    resultId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<VerificationResultResponseV1>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationResultsV1Service.GetVerificationResultV1Path, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.path('resultId', params.resultId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VerificationResultResponseV1>;
      })
    );
  }

  /**
   * Poll a specific verification result by resultId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVerificationResultV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVerificationResultV1(params: {
    requestId: string;
    resultId: string;
  },
  context?: HttpContext

): Observable<VerificationResultResponseV1> {

    return this.getVerificationResultV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<VerificationResultResponseV1>) => r.body as VerificationResultResponseV1)
    );
  }

}
